export enum Stands {
	test = 'test',
	cert = 'cert',
	prod = 'prod',
}
export type StandsKeys = keyof typeof Stands;
